import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "nb_admin_token";

export async function uploadToServer(file) {
  const form = new FormData();
  form.append("file", file);
  const token = localStorage.getItem(TOKEN_KEY);
  const res = await axios.post(`${API}/upload`, form, {
    headers: {
      "Content-Type": "multipart/form-data",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  return `${BACKEND_URL}${res.data.url}`;
}
